import type { MeasurementStrategyContext, PdpMeasurementStrategy } from './PdpMeasurementStrategy';

/**
 * Runs an ordered list of PDP strategies and tears them down in reverse on dispose—mirrors how
 * `removeEventListener` / observer disconnect order must match registration when strategies overlap.
 *
 * Plugin coverage: none — wiring only; individual strategies document which Shopware Store / third-party
 * extensions they aim to tolerate.
 */
export class PdpMeasurementStrategyComposite implements PdpMeasurementStrategy {
  private attached = false;

  constructor(private readonly strategies: readonly PdpMeasurementStrategy[]) {}

  attach(ctx: MeasurementStrategyContext): void {
    if (this.attached) {
      return;
    }
    this.attached = true;
    for (const s of this.strategies) {
      s.attach(ctx);
    }
  }

  dispose(): void {
    if (!this.attached) {
      return;
    }
    this.attached = false;
    for (let i = this.strategies.length - 1; i >= 0; i -= 1) {
      this.strategies[i].dispose();
    }
  }
}
